// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BFEa","footer":"styles_footer__17LpG","passCodeTooltip":"styles_passCodeTooltip__3UrEZ"};